<template>
    <div style="height:100%">
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;height:38px;border-bottom:2px solid #389;padding-top:3px">
 
            <span style="color:black;margin-left:10px;margin-right:5px;font-size:12px">字段查询</span>
            <el-select v-model="selparam"  placeholder="请选择列名" filterable  size="small" style="width:120px; ">
                <span v-for="item in tabCol" :key='item.key' >
                    <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input clearable ref="refinput" :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:320px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
        </div> 
        <el-table :data="tabData"
            border                            
            disabled-hover
            class="custom-table-border"
            :cell-style="{padding:'4px','font-size':'12px',color:'black'}"
            style="overflow:auto;margin-top:1px;"
            header-cell-class-name="clearPadding"
            size="small"
            @row-click="rowClick"
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            :height="300" 
            :row-key="getRowKey"  
            ref="tabref" 
            highlight-current-row>
            <el-table-column label="序号" type="index" width="60" fixed align="center">
                <el-table-column label="序号" type="index" width="60" fixed align="center">
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column  v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key"  :align="item.align"  show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-select v-if="item.key=='STFG'" @change="qryTabData" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                            <el-option label="已审核" value="Y"  ></el-option>
                            <el-option label="未审核" value="N"  ></el-option>
                        </el-select>
                        
                        <el-input type="number" placeholder="数字框"  @keyup.enter.native="qryTabData" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="qryTabData"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-tag v-else-if="item.key=='STFG'" :type="scope.row[item.key]=='Y'?'success':'info'" size="small">{{scope.row[item.key]=='Y'?'已审核':'未审核'}}</el-tag>
                        <el-checkbox v-else-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox>                       
                        <span v-else v-text="scope.row[item.key]" ></span>
                    </template>
                </el-table-column> 
            </el-table-column> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="80">
                <template slot-scope="scope">
                    <span v-if="scope.row.STFG==='Y' " >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click.native.stop="stfgRec(scope.row,'N',$event)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃审</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N' " >
                        <i class="iconfont icon-chenggong1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click.native.stop="stfgRec(scope.row,'Y', $event)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">审核</span></el-link>
 
                    </span>
                </template>
            </el-table-column>                      
        </el-table>  
      
        <div  style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div  class="one-div" style="margin-top:2px;">
            <span class="oneRow"> 退货明细 </span>
      
        </div>
        <el-table  :data="dtlData" 
            border                            
            size="small"
            ref="refdtl"
            class="custom-table-border"
            style="margin-top:-9px"
            header-cell-class-name="clearPadding"
            :cell-style="{padding:'3px 0','font-size':'12px',color:'black'}"
            :height="editHeight" 
            v-loading="t_loading"
            show-summary
            :summary-method="getSummary"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            highlight-current-row >  
            <el-table-column label="序号" type="index" width="60" fixed align="center">
                <el-table-column label="序号" type="index" width="60" fixed align="center">
                    <template slot="header"  >
                        <el-link   @click="dtlShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>   
            <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                :prop="item.key"                 
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <template slot="header"><span v-if="item.notnull=='Y'"  style="color:red">{{item.title}}*</span><span v-else>{{item.title}}</span></template>
                <el-table-column  resizable :prop="item.key"  :align="item.align"  show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-checkbox v-model="v_dtlrow[item.key]" @change="selChg(v_dtlrow[item.key])" v-if="item.edcss=='checkbox'" true-label="Y" false-label="N"></el-checkbox>
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="getDtlData"  v-model="v_dtlrow[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">     
                        <span v-if="saveFlag">
                            <span v-if="item.edcss=='checkbox'">
                                <el-checkbox  true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox>                       
                            </span>
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </span> 
                        <span v-else>
                            <span v-if="item.edcss=='checkbox'">
                                <el-checkbox  true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox>                       
                            </span>
                            <input type="number" @input="numChg(scope.row,scope.$index,item.key)"  v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%">  
                            <input  @input="numChg(scope.row,scope.$index,item.key)" v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> 
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </span>
                    </template>
                </el-table-column>
            </el-table-column>                         
        </el-table> 
  
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
 
 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
 
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>
  
    </div>
</template>
<script>
import repWin from '../datamgt/repWin.vue'  
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate } from '../../api/Select' 
//局部注册
export default {
    name:"outmat_return",
    data () {
        return {
            v_dtlrow:{},
            dateval:'',
            rmkval:'',

            v_row: {},
            v_idno:'',
            v_replist:[],
            repArr:[],
            reqData:[],
            repDlg:false,
            repWin:false,
            repUrl:'',
     
            v_operData:[],
            dtlRow:{},
            sendVal:'PRD',
            saveFlag:false,
            empWin:false,
            promptWin:false,
    
            prompt:'',
            selparam3:'IDNO',
            oper3:'like',
            txtparam3:'',
            selparam4:'',
            oper4:'like',
            txtparam4:'',
            tmplRmk:'',
            stfgCss:'',
 
            stfgColor:'',
            mainRow:{},
            input_hold:'请输入查询的值',
 
            v_idseq:'-1',
            active:'', //二级菜单选中标志
            stfg_:'ALL',
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
  
            dtlValidate:{},
 
            tabData:[], //表数据
            allData:[],
            v_loading:false,
            tabCol:[], //表列
            dtlData:[], //明细数据
            t_loading:false,
            dtlCol:[],
            operArr:[],
            oper:'like',
            oper2:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
  
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            notDtl:[],
            current:1,
            v_oth:'N',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
 
            actitem:'one',
            v_stknm :'',
 
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
      
        }
    },
    mounted () { 
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','488598','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            let row =res.result[0]
            this.v_oth =row['ISOTH']
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
            this.getTabList('')
        })  
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
 
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','407576','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
 
 
        this.showkey()
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 493) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 190) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
 
    },
    components: {
        repWin,
 
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: { 
        
        selChg(val){
            this.dtlData.forEach(item=>{
                item['SEL']=val
            })
        },
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY'||column.property==='OKQTY'||column.property==='DIFFQTY'||column.property==='RTNQTY'){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        numChg(row,index,key){
            if (key =='OKQTY'){
                if (row['OKQTY']>row['QTY']){
                    this.promptWin =true
                    this.prompt ='签收数量不能大于送货数量'
                    row['OKQTY'] =row['QTY']
                    row['DIFFQTY'] =0
                }else{
                    row['DIFFQTY'] =row['QTY']-row['OKQTY']
                }
            }
            if (row['IDSEQ'] && row['LSTSEQ']){
                this.v_operData.push({IDSEQ:row['IDSEQ'],LSTSEQ:row['LSTSEQ']})
            } 
        },
        rowShow(){
            this.v_row ={}
            this.qryTabData()
        } ,
        dtlShow(){
            this.v_dtlrow ={}
            this.getDtlData()
        } ,
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
 
        // 明细select框改变时
        comChg(key,val,arr){
          if (key =='STKNO'){
            arr.some(item=>{
              if (item['CODE']==val)
                this.v_stknm  =item['CNAME']
            })
            //console.log(key,val,JSON.stringify(arr) )
          }
          
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },

 
        //订单明细
        getTabList(cond){
            this.v_loading =true
            if ( this.v_oth=='Y' ){
                cond =cond + ' and stknm=\'' +this.v_usernm+'\''
            }
            this.dtlData=[]
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idty',p_value:'RETURN', p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by '+this.selparam+' desc',p_table:'V_PICK_RTN'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.tabref.doLayout()
                        this.$refs['tabref'].setCurrentRow(this.allData[0])
                        this.v_loading=false
                        if ( this.allData.length>0) {
                            if (this.allData[0]['STFG']=='Y'){
                                this.saveFlag =true
                            }else{
                                this.saveFlag =false 
                            }
                            this.v_idseq =this.allData[0]['IDSEQ']
                        }                        
                        this.getDtlData() //查询明细数据
                    })

                }else{
                    this.promptWin=true
                    this.prompt=res.code+':'+res.result
                    this.v_loading=false
                }
                
            }) 
        },
        //查询明细数据
        getDtlData(){
            this.dtlData=[]
            this.v_operData=[]
            this.t_loading =true
            let v_cond ='' 
            Object.keys(this.v_dtlrow).filter(item=>item!=='SEL').forEach(item=>{
                if (this.v_dtlrow[item] ){
                    v_cond =v_cond +' and  upper('+item+')  like  upper( \'%'+ this.v_dtlrow[item] +'%\') '
                }
            })
            getTabColOrData(this.v_url,'V_PICK_RTNdtl','idseq',this.v_idseq,'','','','',v_cond +' ORDER BY MATNO').then((res) => {                
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.t_loading =false
                    this.$refs['refdtl'].doLayout()
                })
            })
        },
        rowClick(row, event, column) {
            if (row['STFG']==='Y'){
                this.saveFlag =true
            }else{
                this.saveFlag =false 
            }
            this.v_idseq =row['IDSEQ']
            this.getDtlData()
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
        
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        //状态变更
        stfgRec(row,val,event){
            let v_comm='',cond_='',v_user='',v_dttm=''
            if (val==='Y'){
                v_comm='审核'
            }else if (val==='N'){
                v_comm='弃审'
            }else if (val==='X'){
                v_comm='作废'
            }  
            if (val==='Y'){
                v_user =this.v_usernm
                v_dttm =getDate('full')
                cond_=' set STFG=\'Y\' ,chkdttm=\''+v_dttm+'\' ,chkuser=\''+v_user+'\''
            }else{
                v_user =''
                v_dttm =''
                cond_=' set STFG=\''+val+'\' , chkdttm=null  , chkuser=null'
            }
            this.$confirm('你确定要'+v_comm+'此记录吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(async ()=>{
                if (val =='Y') {
                    const v_arr  =Array.from(new Set(this.v_operData.map(JSON.stringify))).map(JSON.parse)  
                    const v_saveArr =this.dtlData.filter(item1 => v_arr.some(item2 => item1.IDSEQ==item2.IDSEQ && item1.LSTSEQ==item2.LSTSEQ ) || !item1.LSTSEQ )                
                    const v_confirm =v_saveArr.map(async item=>{
                        let v_cond=' set qty=\''+item['QTY']+'\',rmk=\''+(item['RMK']||'')+'\''
                        return await this.$axios({   
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq', p_value:item['IDSEQ'],p_key2:'lstseq', p_value2:item['LSTSEQ'], p_table:'PICK_RTNDTL',p_cond:v_cond},
                        }) 
                    })            
                    Promise.all(v_confirm).then(()=>{
                        //console.log('先保存明细')
                    })
                }
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'PICK_RTN',p_cond:cond_},
                }).then(res=>{      
                    if(res.code =='200')  {
                        Object.assign(row,{ CHKUSER:v_user,CHKDTTM:v_dttm})
                        this.$set(row,'STFG',val)
                        this.saveFlag =val==='Y'?true:false
                        this.v_idseq=row['IDSEQ']
                        this.getDtlData()
                    }else{
                        const errorMsg =res.result
                        const startIndex = errorMsg.indexOf("ORA-20001:") 
                        const endIndex = errorMsg.indexOf("请核查") +3
                        const extractedValue = errorMsg.substring(startIndex, endIndex).trim()
                        if (startIndex>0){
                            this.prompt =extractedValue
                        }else{
                            this.prompt =res.result
                        }
                        this.promptWin =true
                    }        
                })
          
            }).catch(()=>{})
             
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+'  like \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                    }

                }
            })
            this.getTabList( cond_+ v_cond)
    
        },
 
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','488598','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','488598','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
 
        }
    }
}
</script>
<style scoped lang="less">
 
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
 
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        height:20px;
    }
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    } 
 
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:12px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
